import React from "react";
import FlashGalleryBrowser from "../../components/FlashGalleryBrowser.jsx";

export default function FlashSection() {
  return (
    <div className="section">
      <div className="label">Browse flash</div>
      <FlashGalleryBrowser />
    </div>
  );
}
